<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">
    <ol class="breadcrumb">
      <li><a href="">{{'global.menu.home' | translate}}</a></li>
      <li><a href="">{{'global.menu.admin.main'|translate}}</a></li>
      <li class="active">Userlock</li>
    </ol>
  </div>
  <div class="col-md-12 noBottomMargin">
    <h2 class="changePasswordHeading">Unlock User</h2>
  </div>
  <div class="col-md-12 mainUserlockDiv">
    <div class="alert alert-success alert-dismissable centerText" *ngIf="success">
      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
      <strong>User unlocked successfully</strong>
    </div>

    <div class="alert alert-danger centerText" *ngIf="error">
      <strong>Something went wrong</strong>
    </div>
    <form [formGroup]="userSearchForm" novalidate (submit)="getuser()">
      <div class="col-md-2 noPaddingMd-12">

      </div>
      <div class="col-md-4 ">
          <input type="text"  id="employeeid" name="employeeid" formControlName="employeeId"
                 autocomplete="off" autofocus required >
          <span class="bar"></span>
          <label>{{'global.form.employeeid' | translate}}</label>
      </div>
      <div class="col-md-4 noPaddingMd-12">
          <input type="text"  id="certificatenumber" name="certificatenumber" formControlName="certificateNumber"
                 autocomplete="off" autofocus required >
          <span class="bar"></span>
          <label>{{'global.form.certificatenumber' | translate}}</label>
      </div>
      <div class="col-md-2 noPaddingMd-12">

      </div>

      <div class="col-md-12"></div>
      <div class="col-md-4 noPaddingMd-12">

      </div>
      <div class="col-md-4 btnDiv">
        <button type="submit"  class="btn btn-primary passBtn" >{{'global.button.search'|translate}}</button>
      </div>
    </form>
    <div class="col-md-4 noPaddingMd-12">

    </div>
    <div class="col-md-12 tableDiv noPaddingMd-12"  >
        <table class="table table-scrollable userTable" >
          <thead>
          <tr>
            <th colspan="2">
              {{'person.certificatenumber' | translate}}

            </th>
            <th colspan="2">
              {{'person.company' | translate}}
            </th>
            <th colspan="2">
              {{'person.name' | translate}}

            </th>
            <th colspan="2">
              {{'person.nik' | translate}}

            </th>
            <th colspan="2">
              &nbsp;

            </th>
          </tr>
          </thead>
          <tbody>
          <tr class="rowBorder" *ngFor="let user of users;let i = index">
            <td colspan="2">{{user.certificateNumber}}</td>
            <td colspan="2" >{{user.companyName}}</td>
            <td colspan="2">{{user.participantName}}</td>
            <td colspan="2">{{user.employeeId}}</td>
            <td colspan="2">
              <button type="button"  class="btn btn-primary userlockBtn" (click)="unlockUser(user.id)">{{'userlock.tableBtn'|translate}}</button>
            </td>
          </tr>
          <tr *ngIf="noData">
            <td colspan="10" class="nodataTr">
                 No users available
            </td>
          </tr>
          </tbody>
        </table>
        <pagination [totalItems]="totalItems" [(ngModel)]="currentPage" (pageChanged)="pageChanged($event)"></pagination>
    </div>
  </div>
</div>
